<template>
  <div style="background-color: #e5e5e5">
    <b-container class="mainSection">
      <OrderDetail :detailData="invoiceData" />
      <div class="lineStyle"></div>
      <Products :productData="invoiceData" />
      <div class="lineStyle"></div>
      <Shipping :shippingData="invoiceData" />
      <div class="lineStyle"></div>
      <PaymentDetail :paymentData="invoiceData" />
      <div class="lineStyle"></div>
      <Description />
    </b-container>
    <b-container class="mainSectionMobile">
      <OrderDetail :detailData="invoiceData" />
    </b-container>
    <b-container class="mainSectionMobile">
      <Products :productData="invoiceData" />
    </b-container>
    <b-container class="mainSectionMobile">
      <Shipping :shippingData="invoiceData" />
    </b-container>
    <b-container class="mainSectionMobile">
      <PaymentDetail :paymentData="invoiceData" />
    </b-container>
    <b-container class="mainSectionMobile">
      <Description />
    </b-container>
  </div>
</template>

<script>
import OrderDetail from './OrderDetail.vue'
import Products from './Products.vue'
import Shipping from './Shipping.vue'
import PaymentDetail from './PaymentDetail.vue'
import invoiceDataProvider from '../../../services/invoice'
import Description from './Description.vue'
export default {
  components: {
    OrderDetail,
    Products,
    Shipping,
    PaymentDetail,
    Description,
  },
  data() {
    return {
      invoiceData: null,
    }
  },
  beforeMount() {
    const route = this.$route
    invoiceDataProvider
      .getInvoiceDetails({
        invoiceId: route.params.id,
      })
      .then((res) => {
        this.invoiceData = res.data.data.invoice
      })
  },
}
</script>

<style scoped lang="scss">
.mainSection {
  display: block;
  overflow: auto;
  background: #ffffff;
  border-radius: 8px;
  padding: 30px 45px;
  margin: 32px auto;
}
.mainSectionMobile {
  display: none;
  overflow: auto;
  background: #ffffff;
  border-radius: 8px;
  padding: 15px 20px;
  margin: 16px auto;
}
.lineStyle {
  margin: 20px 0;
  height: 1px;
  background: #c4c4c4;
  border-radius: 40px;
}
@media only screen and (max-width: 576px) {
  .mainSection {
    display: none;
  }
  .mainSectionMobile {
    display: block;
  }
  ::v-deep .container {
    width: 92% !important;
  }
}
</style>
